"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberWithholdingStatus = exports.TaxFilingCode = exports.TaxFilingType = exports.Interests = exports.WingspanProductAspects = exports.WingspanProducts = exports.FreelanceType = exports.FreelanceDuration = exports.BookkeepingProductsUsed = exports.Visibility = void 0;
var Visibility;
(function (Visibility) {
    Visibility["Private"] = "Private";
    Visibility["ClientVisible"] = "ClientVisible";
    Visibility["Public"] = "Public";
})(Visibility = exports.Visibility || (exports.Visibility = {}));
var BookkeepingProductsUsed;
(function (BookkeepingProductsUsed) {
    BookkeepingProductsUsed["AccountingSoftware"] = "AccountingSoftware";
    BookkeepingProductsUsed["CPA"] = "CPA";
    BookkeepingProductsUsed["PenAndPaper"] = "PenAndPaper";
    BookkeepingProductsUsed["Spreadsheet"] = "Spreadsheet";
    BookkeepingProductsUsed["Other"] = "Other";
})(BookkeepingProductsUsed = exports.BookkeepingProductsUsed || (exports.BookkeepingProductsUsed = {}));
;
var FreelanceDuration;
(function (FreelanceDuration) {
    FreelanceDuration["LessThanOne"] = "LessThanOne";
    FreelanceDuration["OneToThree"] = "OneToThree";
    FreelanceDuration["ThreeToFive"] = "ThreeToFive";
    FreelanceDuration["OverFive"] = "OverFive";
})(FreelanceDuration = exports.FreelanceDuration || (exports.FreelanceDuration = {}));
var FreelanceType;
(function (FreelanceType) {
    FreelanceType["Team"] = "Team";
    FreelanceType["FullTime"] = "FullTime";
    FreelanceType["PartTime"] = "PartTime";
    FreelanceType["NotFreelancing"] = "NotFreelancing";
})(FreelanceType = exports.FreelanceType || (exports.FreelanceType = {}));
var WingspanProducts;
(function (WingspanProducts) {
    WingspanProducts["Payments"] = "Payments";
    WingspanProducts["Bookkeeping"] = "Bookkeeping";
    WingspanProducts["Benefits"] = "Benefits";
})(WingspanProducts = exports.WingspanProducts || (exports.WingspanProducts = {}));
var WingspanProductAspects;
(function (WingspanProductAspects) {
    WingspanProductAspects["Invoicing"] = "Invoicing";
    WingspanProductAspects["PaymentSpeed"] = "PaymentSpeed";
    WingspanProductAspects["ClientManagement"] = "ClientManagement";
    WingspanProductAspects["TrackIncomeStreams"] = "TrackIncomeStreams";
    WingspanProductAspects["ExpenseTracking"] = "ExpenseTracking";
    WingspanProductAspects["TaxDeductions"] = "TaxDeductions";
    WingspanProductAspects["TaxFiling"] = "TaxFiling";
    WingspanProductAspects["HealthInsurance"] = "HealthInsurance";
    WingspanProductAspects["SavingMoneyOnMedicine"] = "SavingMoneyOnMedicine";
    WingspanProductAspects["LegalAndFinancialSupport"] = "LegalAndFinancialSupport";
    WingspanProductAspects["MindAndBodySupport"] = "MindAndBodySupport";
})(WingspanProductAspects = exports.WingspanProductAspects || (exports.WingspanProductAspects = {}));
var Interests;
(function (Interests) {
    Interests["Incorporating"] = "Incorporating";
    Interests["Marketing"] = "Marketing";
    Interests["FindingWork"] = "FindingWork";
    Interests["Documents"] = "Documents";
    Interests["Invoicing"] = "Invoicing";
    Interests["Bookkeeping"] = "Bookkeeping";
    Interests["TaxSaving"] = "TaxSaving";
    Interests["Benefits"] = "Benefits";
    Interests["Community"] = "Community";
})(Interests = exports.Interests || (exports.Interests = {}));
var TaxFilingType;
(function (TaxFilingType) {
    TaxFilingType["personal"] = "Personal";
    TaxFilingType["business"] = "Business";
})(TaxFilingType = exports.TaxFilingType || (exports.TaxFilingType = {}));
var TaxFilingCode;
(function (TaxFilingCode) {
    TaxFilingCode["Single"] = "S";
    TaxFilingCode["Married"] = "M";
    TaxFilingCode["HeadOfHousehold"] = "H";
    TaxFilingCode["MarriedFilingSeparately"] = "MS";
    TaxFilingCode["QualifiedWidower"] = "QW";
})(TaxFilingCode = exports.TaxFilingCode || (exports.TaxFilingCode = {}));
var MemberWithholdingStatus;
(function (MemberWithholdingStatus) {
    MemberWithholdingStatus["Active"] = "Active";
    MemberWithholdingStatus["Paused"] = "Paused";
})(MemberWithholdingStatus = exports.MemberWithholdingStatus || (exports.MemberWithholdingStatus = {}));
//# sourceMappingURL=member.js.map